export default __webpack_public_path__ + "static/media/This-is-your-home.8a3826e7.webp";